import api from '@/utils/api.js'

export const APIGetStores = async (json, noLoading = false) => {
  try {
    let res = await api('v2/store/GetStores', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/**
 * 添加平台门店绑定
 * @param {*} storeID
 * @param {*} vendorID
 * @param {*} vendorOrgCode 选填
 * @param {*} payload {"vendorStoreID":"103083","autoPickup":1,"deliveryCompetition":1,"pricePercentage":100,"isSync":1,"pricePercentagePack":"美团调价策略7.18"}
 */
export const APIAddStoreMap = async (json, noLoading = false) => {
  try {
    let res = await api('v2/store/AddStoreVendorMap', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/**
 * 修改平台门店绑定
 * @param {*} storeID
 * @param {*} vendorID
 * @param {*} payload {"vendorStoreID":"103083","autoPickup":1,"deliveryCompetition":1,"pricePercentage":100,"isSync":1,"pricePercentagePack":"美团调价策略7.18"}
 */
export const APIUpdateStoreMap = async (json, noLoading = false) => {
  try {
    let res = await api('v2/store/UpdateStoreVendorMap', {
      method: 'PUT',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/* 发送消息
  storeIDs
  title
  content
  isAsync
  isContinueWhenError
*/
export const APISendStoreMessage = async (string, noLoading = true) => {
  try {
    let res = await api('v2/msg/SendStoreMessage', {
      method: 'POST',
      data: string,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APISendStoreMessage', e)
    throw e
  }
}

/*
  更新门店信息
  storeID
  payload
*/
export const APIUpdateStore = async (json, noLoading = true) => {
  try {
    let res = await api('v2/store/UpdateStore', {
      method: 'PUT',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/* 查询远端门店
vendorStoreID
vendorID
vendorOrgCode
*/
export const APIGetVendorStore = async (json) => {
  try {
    const res = await api('v2/store/GetVendorStore', {
      params: {
        ...json
      },
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/apis/APIshop.js